import { createFileRoute } from '@tanstack/react-router';
import { WizardStepRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportUploadPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportUploadRoute() {
  return (
    <LastWorkspaceResolver>
      <WizardStepRouteView step="upload">
        <ImportUploadPage />
      </WizardStepRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/')({
  validateSearch: validateWizardSearch,
  component: ImportUploadRoute,
});
